import { useEffect, useState } from "react";
import { trackWhatsAppClick } from "../services/trackingService";
import { buildWhatsAppUrl, WHATSAPP_MESSAGES } from "../constants/whatsapp";
import WhatsAppIcon from "./ui/WhatsAppIcon";

const SCROLL_THRESHOLD = 150;

const WhatsAppButton = ({ visible = false }) => {
  const [shouldLift, setShouldLift] = useState(false);

  useEffect(() => {
    const syncButtonOffset = () => {
      const scrollTop = Math.max(
        document.body.scrollTop,
        document.documentElement.scrollTop,
      );

      setShouldLift(scrollTop > SCROLL_THRESHOLD);
    };

    syncButtonOffset();
    window.addEventListener("scroll", syncButtonOffset);

    return () => {
      window.removeEventListener("scroll", syncButtonOffset);
    };
  }, []);

  if (!visible) return null;

  const url = buildWhatsAppUrl(WHATSAPP_MESSAGES.default);

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      onClick={() => trackWhatsAppClick("whatsapp_floating_button")}
      style={{ animation: 'whatsapp-float 2.4s ease-in-out infinite' }}
      className={`fixed right-3 z-50 bg-[#25D366] hover:bg-[#1fb855] text-white rounded-full w-16 h-16 flex items-center justify-center transition-all duration-300 hover:scale-110 ${shouldLift ? "bottom-20" : "bottom-3"}`}
    >
      <WhatsAppIcon className="w-8 h-8" />
    </a>
  );
};

export default WhatsAppButton;
